// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"5e078947","179":"4b963a9a","228":"ef8fa907","272":"8ec62dfe","352":"09f85da6","549":"5bceb1d0","666":"b2c655b9","816":"06043065","930":"0b18930c","996":"961af945"}[chunkId] + ".chunk.js";
};